import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Picker from '../base/Picker/Picker';
import * as modalActions from '../../actions/Modal';
import textTranslates from './translate.json';

class ProductPicker extends Component {

    onPickerButtonClick = () => this.props.openProductPickerModal();

    render() {
        return(
            <Picker
                buttonId="complaintPositionChangeProductBtn"
                buttonText={textTranslates.pickerChangeProductBtn}
                inputId={this.props.componentId}
                inputLabel={textTranslates.pickerProductInputLabel}
                inputPlaceholder={textTranslates.pickerInputPlaceholder}
                inputValue={this.props.product.name}
                onPickerButtonClick={this.onPickerButtonClick}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        product: state.complaintPosition.product
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        openProductPickerModal: () => dispatch(modalActions.openProductPickerModal()),
    };
};

ProductPicker.propTypes = {
    componentId: PropTypes.string,
    openProductPickerModal: PropTypes.func,
    product: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPicker);


// WEBPACK FOOTER //
// ./src/components/Product/ProductPicker.js